import type { FunctionComponent } from 'react'
import { useCallback } from 'react'
import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js'
import Share from '../../../assets/icons/share.svg'
import getShareUrl, { ShareTarget } from '../../../utils/shareUrl'
import Facebook from '../../../assets/icons/facebook.svg'
import XIcon from '../../../assets/icons/xLogo.svg'
import LinkedIn from '../../../assets/icons/linkedIn.svg'
import WhatsApp from '../../../assets/icons/whatsapp.svg'
import Embed from '../../../assets/icons/embed.svg'
import { isAuthenticated } from '../../../utils/auth/auth'
import { Menu, MenuButton as ShareButton } from './Menu'

interface ShareMenuProps {
  setShareMenu: (shareMenu: boolean) => void
}
const ShareMenu: FunctionComponent<ShareMenuProps> = ({ setShareMenu }) => {
  const appInsights = useAppInsightsContext()
  const trackShareEvent = useTrackEvent(appInsights, 'SHARE_MAP', {})
  const trackEmbedEvent = useTrackEvent(appInsights, 'EMBED_MAP', {})

  const handleGetUrl = useCallback(
    async (type: string) => {
      setShareMenu(false)

      const params = new URLSearchParams(window.location.search)
      if (isAuthenticated() && type === 'share') {
        trackShareEvent({ category: 'map', params })
      }
      if (isAuthenticated() && type === 'embed') {
        trackEmbedEvent({ category: 'map', params })
      }

      if (type === 'embed') {
        params.set('embed', 'true')
      }

      await navigator.clipboard.writeText(
        `${window.location.origin}${window.location.pathname}?${params.toString()}`,
      )
      // eslint-disable-next-line no-alert
      alert('URL is gekopieerd naar klembord')
    },
    [trackShareEvent, trackEmbedEvent, setShareMenu],
  )

  const handlePageShare = (target: ShareTarget) => {
    if (isAuthenticated()) {
      const params = new URLSearchParams(window.location.search)
      trackShareEvent({ category: 'map', params })
    }

    const link = getShareUrl(target)
    if (link) {
      window.open(link.url, link.target)
    }
  }

  return (
    <Menu className="share">
      <ul>
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <ShareButton handleClick={() => handleGetUrl('share')} type="share">
          <>
            <Share />
            Kopieer link
          </>
        </ShareButton>
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <ShareButton handleClick={() => handleGetUrl('embed')} type="share">
          <>
            <Embed />
            Embed
          </>
        </ShareButton>
        <ShareButton handleClick={() => handlePageShare(ShareTarget.LinkedIn)} type="share">
          <>
            <LinkedIn />
            LinkedIn
          </>
        </ShareButton>
        <ShareButton handleClick={() => handlePageShare(ShareTarget.Facebook)} type="share">
          <>
            <Facebook />
            Facebook
          </>
        </ShareButton>
        <ShareButton handleClick={() => handlePageShare(ShareTarget.WhatsApp)} type="share">
          <>
            <WhatsApp />
            Whatsapp
          </>
        </ShareButton>
        <ShareButton handleClick={() => handlePageShare(ShareTarget.Twitter)} type="share">
          <>
            <XIcon />X
          </>
        </ShareButton>
      </ul>
    </Menu>
  )
}

export default ShareMenu
